import { Platform } from 'react-native'
import { Stack } from 'expo-router'
import { stableStackOptions } from '../../lib/navigation/stable-stack-options'

const webSwap = Platform.OS === 'web' ? stableStackOptions : {}

/**
 * Public legal stack — accessible without authentication so welcome /
 * register screens (and external Google OAuth deep-links) can show the
 * full policy in-app instead of opening a Safari window. AuthGate in
 * app/_layout.tsx checks `inPublicGroup === firstSegment === 'legal'`
 * to skip the auth redirect for any /legal/* path.
 *
 * Routes mirror the marketing-site slugs (terms-of-service /
 * privacy-policy / cancellation-policy) so a single URL works on both
 * surfaces. Legacy `terms` / `privacy` routes also exist as redirects
 * to keep older deep-links alive.
 */
export default function LegalLayout() {
  return (
    <Stack screenOptions={{ headerShown: false, ...stableStackOptions, ...webSwap }}>
      <Stack.Screen name="terms-of-service" />
      <Stack.Screen name="privacy-policy" />
      <Stack.Screen name="cancellation-policy" />
      <Stack.Screen name="terms" />
      <Stack.Screen name="privacy" />
    </Stack>
  )
}
